exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unique-purple[data-v-6739839a]{background:#8e8ad3}.chapter-list-area[data-v-6739839a]{overflow-y:auto;height:50vh}", ""]);

// exports
